import { Typography } from 'antd';
import * as React from 'react';

import { FormListNoContentStub } from 'assets/images';
import { BaseStub } from 'components/ui';

import s from './NoContentStub.module.scss';
import { TEXTS_DATA } from './texts';

const NoContentStub: React.FC = () => {
  return (
    <div className={s.noContentStub}>
      <BaseStub
        imageNode={<FormListNoContentStub />}
        textNode={
          <Typography.Text type="secondary">{TEXTS_DATA.INFO}</Typography.Text>
        }
      />
    </div>
  );
};

export default React.memo(NoContentStub);
